import Image from 'common/components/Image'
import { WEB_DESKTOP_RALALI_URL } from 'common/constants'
import cdn from 'lib/cdn'
import React from 'react'
import styled from 'styled-components'

const MyProfileContainer = styled.a`
  width: auto;
  box-sizing: border-box;
  border-right: ${({ isRevamp }) =>
    isRevamp ? 'none' : '1px solid ${theme.colors.grayLightAlt'}};
  display: flex;
  justify-content: center;
  align-items: center;
`

function UserProfileButton({
  imageProfile,
}: {
  imageProfile: string
}): JSX.Element {
  return (
    <MyProfileContainer
      href={`${WEB_DESKTOP_RALALI_URL}/customer/profile`}
    >
      <>
        <Image
          src={cdn({
            path: `/assets/img/profile/${imageProfile}`,
          })}
          objectFit="cover"
          radius="50%"
          width="34px"
          height="34px"
        />
      </>
    </MyProfileContainer>
  )
}

export default UserProfileButton
